import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CancelConfirmDialogComponent } from './dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { log } from 'util';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "bimbo";

  constructor(
    private _swUpdate: SwUpdate,
    private _dialog: MatDialog,
  ) {}

  ngOnInit() {
    console.log("Version SW");

    this.clearServiceWorkerAndReload();
  }

  async clearServiceWorkerAndReload() {
    try {
      let limpiaRealizada = false;

      // 1. Limpiar el Cache Storage de Angular
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        const ngswCaches = cacheNames.filter((name) =>
          name.startsWith("ngsw:"),
        );

        if (ngswCaches.length > 0) {
          await Promise.all(ngswCaches.map((name) => caches.delete(name)));
          console.log("Cachés de Angular eliminadas.");
          limpiaRealizada = true;
        }
      }

      // 2. Desregistrar los Service Workers activos
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        if (registrations.length > 0) {
          await Promise.all(registrations.map((reg) => reg.unregister()));
          console.log("Service Workers desregistrados.");
          limpiaRealizada = true;
        }
      }

      // 3. Forzar la recarga SOLO si se eliminó algo y no hemos recargado en esta sesión
      if (limpiaRealizada && !sessionStorage.getItem("sw_limpiado")) {
        sessionStorage.setItem("sw_limpiado", "true");
        console.log(
          "Forzando recarga de la aplicación para aplicar cambios...",
        );
        window.location.reload();
      }
    } catch (error) {
      console.error("Error durante la limpieza del Service Worker:", error);
    }
  }
}

